// extracted by mini-css-extract-plugin
export default {"label":"Checkbox_label__93Jy-","checked":"Checkbox_checked__eMEMN"};